
function Aboutus(){
    return(
        <div>
            <h1>About us</h1>
            <p className="">Welcome to our versatile text modification tool! Our website offers a comprehensive set of features designed to enhance your text editing experience. Whether you need to convert text to uppercase or lowercase, encode it in Base64, or copy it with ease, we've got you covered.

Our intuitive interface makes it simple to manipulate text in various ways, allowing you to quickly achieve your desired formatting. Whether you're a professional writer, coder, or simply someone who needs to tweak text for a specific purpose, our tool provides the flexibility and functionality you need.

With a wide range of options at your fingertips, including text transformation, encoding, and copying functionality, our website is your go-to destination for all your text modification needs. Explore our features today and discover how easy it is to modify text exactly the way you want it</p>
        </div>
    );
}

export default Aboutus;
